import GroupContacts from '@/Component/Admin/GroupContacts'

const GroupContactsPage = () => {
  return (
    <GroupContacts />
  )
}

export default GroupContactsPage
